<template>
  <div class="form-title cr-text-black-1">
    <div class="line"></div>
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.form-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-weight: bold;
  line-height: 14px;
  .line {
    width: 3px;
    height: 14px;
    background: @theme-color;
    margin-right: 10px;
  }
}
</style>
